import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

let root = document.getElementById("root");
let campaign = root.dataset.campaign;
let event = root.dataset.event;
let startPage = root.dataset.startPage;
let campaignInfo = JSON.parse(root.dataset.campaignInfo);

ReactDOM.render(
    <App
        campaign={campaign}
        event={event}
        startPage={startPage}
        campaignInfo={campaignInfo}
    />,
    document.getElementById("root")
);
